import { io } from 'socket.io-client';

const URL = process.env.REACT_APP_COACH_SOCKET_BASE_URL;

export const socket = io(URL, {
    autoConnect: false,
    reconnectionDelay: 10000,
    reconnectionDelayMax: 10000
});